import { render, staticRenderFns } from "./OnboardingQuestionEdit.vue?vue&type=template&id=35ad20b9&"
import script from "./OnboardingQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./OnboardingQuestionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports